import React, {Component} from "react";
import {NavDropdown} from "react-bootstrap";
import {connect} from "react-redux";
import {fetchNotificaiton} from "../../redux/actions/Socket.Action";

class Notification extends Component {
  componentDidMount() {
    this.props.fetchNotificaiton();
  }
  render() {
    return (
      <NavDropdown
        className="dropdown"
        title={<span className="material-icons-outlined">notifications</span>}
      >
        <div className="media-list media-list-hover media-list-divided media-list-xs">
          <a className="media media-new" href="#_">
            <span className="avatar bg-success">
              <i className="ti-user" />
            </span>
            <div className="media-body">
              <p>New user registered</p>
              <time dateTime="2018-07-14 20:00">Just now</time>
            </div>
          </a>
          <a className="media" href="#_">
            <span className="avatar bg-info">
              <i className="ti-shopping-cart" />
            </span>
            <div className="media-body">
              <p>New order received</p>
              <time dateTime="2018-07-14 20:00">2 min ago</time>
            </div>
          </a>
          <a className="media" href="#_">
            <span className="avatar bg-warning">
              <i className="ti-face-sad" />
            </span>
            <div className="media-body">
              <p>
                Refund request from <b>Ashlyn Culotta</b>
              </p>
              <time dateTime="2018-07-14 20:00">24 min ago</time>
            </div>
          </a>
          <a className="media" href="#_">
            <span className="avatar bg-primary">
              <i className="ti-money" />
            </span>
            <div className="media-body">
              <p>New payment has made through PayPal</p>
              <time dateTime="2018-07-14 20:00">53 min ago</time>
            </div>
          </a>
        </div>
        <div className="dropdown-footer">
          <div className="left">
            <a href="#_">Read all notifications</a>
          </div>
          <div className="right">
            <a
              href="#_"
              data-provide="tooltip"
              data-original-="Mark all as read"
            >
              <i className="fa fa-circle-o" />
            </a>
            <a href="#_" data-provide="tooltip" data-original-="Update">
              <i className="fa fa-repeat" />
            </a>
            <a href="#_" data-provide="tooltip" data-original-="Settings">
              <i className="fa fa-gear" />
            </a>
          </div>
        </div>
      </NavDropdown>
    );
  }
}
export default connect(
  (state) => ({
    Notification: state.Socket.notification,
  }),
  {
    fetchNotificaiton,
  }
)(React.memo(Notification));
